// extracted by mini-css-extract-plugin
module.exports = {"product-item":"OrderListItemProduct_product-item_2v_QW","title":"OrderListItemProduct_title_1pLzA","date":"OrderListItemProduct_date_1WSJT"};